import { Modal } from 'flowbite-react';
import { FormikProvider, useFormik } from 'formik';
import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';
import VelotrackActivate from './fields/UploadInfoApis/VelotrackActivate';
import AssasActivate from './fields/UploadInfoApis/AssasActivate';
import ZapSignActivate from './fields/UploadInfoApis/ZapSignActivate';
import "./ApproveRenter.scss"
import { useEffect, useMemo, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import ZapSignConfirmation from './fields/UploadInfoApis/ZapSignConfirmation';
import { createContract } from '../../services/integration.api';
import { saveVehicleRecords } from '../../../../common/services/vehicles.api';
import { approveRenter } from '../../../../common/services/renters.api';
import { SignatureInfo } from '../../../../types/renter.type';
import FormActivateRenterMotoClub from '../forms/FormActivateRenterMotoClub';

export type Props = {
  renter: { _id: string, name: string }
  onClose: () => void
}

export default function ModalApproveRenterMotoClub(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()
  const [isApproved, setIsApproved] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);
  const [signatureInfo, setSignatureInfo] = useState<SignatureInfo>()
  const today = new Date(); // Obtenha a data atual no formato YYYY-MM-DD
  const initialValues = {
    renterId: props.renter._id,
    renterName: props.renter.name,
    vehicle: {
      _id: "",
      licensePlate: "",
    },
    period: {
      value: "",
      label: "",
      months: 0,
    },
    additions: [],
    depositInstallments: 0,
    registers: [
      { type: 'Frente do veículo', content: '' },
      { type: 'Lateral direita do veículo', content: '' },
      { type: 'Lateral esquerda do veículo', content: '' },
      { type: 'Traseira do veículo', content: '' },
      { type: 'Odômetro', content: '' },
      { type: 'Foto com o cliente', content: '' },
      { type: 'Print do real condutor / aceite do real condutor', content: '' }
    ],
    subscriptionInitialDate: today,
    valueDepositInstallments: 0,
    installmentOption: "",
    methodPayment: "",
    contractType: "motoclub",
  }

  const formik = useFormik({
    initialValues,
    // validationSchema,
    onSubmit: async (data) => {

      const activationData = {
        renterId: data.renterId,
        vehicleId: data.vehicle._id,
        depositInstallments: data.depositInstallments,
        period: data.period,
        additions: data.additions,
        deposit: data.depositInstallments,
        subscriptionInitialDate: data.subscriptionInitialDate,
        installmentOption: data.installmentOption,
      }
      const result = await approveRenter(activationData)

      if (!result.ok) {
        notifyError(result.message as string)
        setSubmitResult('error');
        return
      }

      notifySuccess("Solicitação emitida, Aguardando pagamentos para concluir a ativação")
      setSubmitResult('success');

      if (result.ok) {
        const savePhotoDelivery = {
          renterId: data.renterId,
          vehicleId: data.vehicle._id,
          photos: data.registers,
          nameRenter: data.renterName,
          licensePlate: data.vehicle.licensePlate,
        }
        const resultPhoto = await saveVehicleRecords(savePhotoDelivery)
        if (!resultPhoto.ok) {
          notifyError(resultPhoto.message as string)
          setSubmitResult('error');
          return
        }

        notifySuccess("Fotos salvas com sucesso");

      }

      // props.onClose && props.onClose()
    }
  })

  const depositData = {
    renterId: formik.values.renterId,
    valueDepositInstallments: formik.values.valueDepositInstallments,
    methodPayment: formik.values.methodPayment,
    installmentOption: formik.values.installmentOption,
    depositInstallments: parseFloat(String(formik.values.depositInstallments).replace(/\D/g, "")) / 100,
    contractType: "motoclub"
  };


  // Verificação de vehicle._id
  const vehicle = formik.values.vehicle;

  // Atualizando o contractData com verificação de vehicle._id
  const contractData = {
    renterId: formik.values.renterId,
    vehicleId: vehicle && vehicle._id ? vehicle._id : "", // Checagem se vehicle existe
    period: formik.values.period,
    additions: formik.values.additions,
  };

  const badgeColor = useMemo(() =>
    (submitResult == "success")
      ? 'text-greenPrimary'
      : 'text-redPrimary'
    , [submitResult])

  useEffect(() => {
    setIsApproved(submitResult === 'success')
  }, [submitResult]);

  function handleSignature(contractInfo) {
    setSignatureInfo(contractInfo)
  }

  return (
    <Modal
      show={true}
      onClose={() => props.onClose()}>
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header className='text-black'>
            <h2 className='text-black'>Aprovar {props.renter.name}</h2>
          </Modal.Header>
          <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(100vh - 300px)', height: 'calc(100vh - 300px)' }}>
            <FormActivateRenterMotoClub />
            <div className="p-0 grid-class">
              <div>
                <h2 className="font-semibold ">Clique aqui para vincular o veículo no cliente:</h2>
              </div>
              <div className="grid-div2">
                <ButtonWithLoader
                  isLoading={formik.isSubmitting}
                  disabled={!(formik.values?.vehicle?._id)}
                  onSave={() => setIsApproved(true)}>
                  Vincular
                </ButtonWithLoader>
                <FaCheckCircle size={24} className={`${badgeColor}`} />
              </div>
            </div>
            <div className='grid-template'>
              <VelotrackActivate
                disabled={!isApproved}
                onSave={function (): void {
                  throw new Error('Function not implemented.');
                }}
                renterId={formik.values.renterId} />
              <AssasActivate
                disabled={!isApproved}
                onSave={function (): void {
                  throw new Error('Function not implemented.');
                }} depositData={depositData} />
              <ZapSignActivate
                disabled={!isApproved}
                onSave={function (): void {
                  throw new Error('Function not implemented.');
                }} contractData={contractData}
                handleSignature={handleSignature}
                contractFn={createContract} />
              {signatureInfo?.ok && (
                <ZapSignConfirmation
                  contractInfo={signatureInfo}
                />)}
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>
      <Modal.Footer>
      </Modal.Footer>
    </Modal >
  );
}
